// 📁 usePatientStatus.js

import { useState } from 'react'

import { callPatientStatusApi, fetchCheckForUpdate } from '../components/shared/checkForUpdateApi'
import { insertPatient, updatePatient, deletePatient, appendPatientToToday } from '../utils/checkForUpdateUtils'
// import { callPatientStatusApi } from './patientStatusApi'


export const usePatientStatus = (initialData = {}) => {
  const [data, setData] = useState(initialData)



  const appendPatientInTodaysList = async ({ existingPatientData, providerId, patientId, id, date }) => {
    const appendData = appendPatientToToday(existingPatientData, { providerId, patientId, date })
    await callPatientStatusApi('UPDATE', appendData, id)
  }


  const addPatient = async ({ providerId, patientId, date }) => {
    const updated = insertPatient(data, { providerId, patientId, date })
    await callPatientStatusApi('INSERT', updated)
  }


  const updatePatientData = async ({existingPatientData, providerId, patientId, updates, id, date }) => {
    const updated = updatePatient(existingPatientData, { providerId, patientId, updates, date })
    console.log("updateDData", updated)
    await callPatientStatusApi('UPDATE', updated, id)
  }


  const removePatient = async ({ providerId, patientId, date }) => {
    const updated = deletePatient(data, { providerId, patientId, date })
    await callPatientStatusApi('DELETE', updated, id)
  }

  return {
    data,
    appendPatientInTodaysList,
    addPatient,
    updatePatientData,
    removePatient,
  }
}